import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

type PromoterState = {
  isLoading: boolean,
  error: any,
  data: any,
  codeFormData: any,
  isError: boolean,
  description: string,
  title: string,
  terms: {
    title: string,
    version: string,
    contentUrl: string,
    contentHtml: string,
  }
}

const initialState: PromoterState = {
  isLoading: false,
  error: null,
  data: null,
  codeFormData: null,
  isError: false,
  description: '',
  title: '',
  terms: {
    title: '',
    version: '',
    contentUrl: '',
    contentHtml: '',
  },
};

const slice = createSlice({
  name: 'promoter',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    stopLoading(state) {
      state.isLoading = false;
    },
    setModalInfos(state, action) {
      state.description = action.payload.description;
      state.title = action.payload.title;
      state.isError = action.payload.isError;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    },

    setPhoneFormData(state, action) {
      state.codeFormData = action.payload
    },

    setTerms(state, action) {
      state.terms = action.payload;
    }
  },
});

export default slice.reducer;

export const { setPhoneFormData, setTerms } = slice.actions;

export function verifyPromoter(code: string, password: string) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      var response = await axios.post('/auth/promoter-login-management', { "code": code, "password": password, userType: "promoter" });
      dispatch(slice.actions.stopLoading());
      return response.data
    } catch (error) {
      dispatch(slice.actions.setModalInfos(
        {
          title: "Credenciais inválidas. Confira se seu código e senha estão corretos.",
          description: "",
          isError: true
        }
      ));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function acceptTerms(termsVersion: string, device: string) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      var response = await axios.post('/auth/promoter-terms/accept', { termsVersion, device });
      dispatch(slice.actions.stopLoading());
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTerms() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      var response = await axios.get('/auth/promoter-terms/check');
      dispatch(slice.actions.stopLoading());
      dispatch(slice.actions.setTerms({
        title: response.data.terms.title,
        version: response.data.terms.version,
        contentUrl: response.data.terms.contentUrl,
        contentHtml: response.data.terms.contentHtml,
      }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  }
}

export function definitivePassword(code: string, password: string) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      var response = await axios.put('/auth/definitive-password-management', { code, password });
      dispatch(slice.actions.stopLoading());
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function forgotPassword(code: string) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      var response = await axios.post('/auth/reset-password-management', { code });
      dispatch(slice.actions.stopLoading());
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function expireToken(refreshToken: string) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      var response = await axios.post('/auth/invalid-refresh-token', { refreshToken });
      dispatch(slice.actions.stopLoading());
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
